import React from 'react';
import styled from 'styled-components';

const UserReviewLeftComponent = () => (
  <UserReviewLeftComponentWrapDiv>
    <UserImageWrapDiv></UserImageWrapDiv>
  </UserReviewLeftComponentWrapDiv>
);

export default UserReviewLeftComponent;

const UserReviewLeftComponentWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;

  width:5%;
  justify-content: space-between;


`,
);

const UserImageWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:50%;
  width:5rem;
  height:5rem;



`,
);
